import st_observer from './st_observer'

export default st_observer